export default __webpack_public_path__ + "static/media/teferi.dd2b8aa0.jpg";